import { useState } from 'react';

export default function Stars({ value, onChange, readonly = false, size = 20 }) {
  const [hov, setHov] = useState(0);
  return (
    <div style={{display:'flex',gap:3}}>
      {[1,2,3,4,5].map(s => (
        <span key={s}
          style={{fontSize:size,cursor:readonly?'default':'pointer',color:(hov||value)>=s?'#F4A435':'#E5D9C8',transition:'transform .1s',display:'inline-block'}}
          onClick={() => !readonly && onChange && onChange(s)}
          onMouseEnter={() => !readonly && setHov(s)}
          onMouseLeave={() => !readonly && setHov(0)}>★</span>
      ))}
    </div>
  );
}
